import { BuildOptimize } from 'actions';

const initialState = {
  isFetching: false,
  search: [],
  portfolio: {},
  riskMetric: 'variance',
  prevEF: {},
  minWeight: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case BuildOptimize.BUILDOPTIMIZE_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case BuildOptimize.BUILDOPTIMIZE_ADD_SUCCESS:
      return !action.security
        ? { ...state, isFetching: false }
        : {
            ...state,
            isFetching: false,
            portfolio: {
              ...state.portfolio,
              [action.security.ticker]: {
                ...action.security,
                weight: 0,
              },
            },
          };
    case BuildOptimize.BUILDOPTIMIZE_LOAD_PORTFOLIO:
      return {
        ...state,
        isFetching: false,
        portfolio: action.portfolio,
        gic_info: action.gicInfo,
      };
    case BuildOptimize.BUILDOPTIMIZE_SEARCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        search: action.data,
      };
    case BuildOptimize.BUILDOPTIMIZE_REMOVE_SECURITY:
      return {
        ...state,
        isFetching: false,
        portfolio: Object.values(state.portfolio).reduce(
          (newPortfolio, item) => {
            if (item.ticker !== action.ticker) {
              newPortfolio[item.ticker] = item;
            }

            return newPortfolio;
          },
          {}
        ),
        gic_info: action.ticker === 'GIC1:MKT' ? {} : state.gic_info,
      };
    case BuildOptimize.BUILDOPTIMIZE_UPDATE:
      return {
        ...state,
        [action.field]: action.value,
      };
    case BuildOptimize.BUILDOPTIMIZE_REMOVE_ALL:
      return {
        ...state,
        isFetching: false,
        portfolio: {},
        gic_info: {},
      };
    case BuildOptimize.BUILDOPTIMIZE_CLEAR:
      return initialState;
    default:
      return state;
  }
}
